import { render } from "./PlayerStatusBar.vue?vue&type=template&id=760f2edb&scoped=true"
import script from "./PlayerStatusBar.vue?vue&type=script&lang=js"
export * from "./PlayerStatusBar.vue?vue&type=script&lang=js"

import "./PlayerStatusBar.vue?vue&type=style&index=0&id=760f2edb&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-760f2edb"]])

export default __exports__